import { useTranslation } from 'react-i18next';
import { Stepper, Divider, Icon } from '@treezor/design-system';

import { TUserCreationType } from '@/store/models/dashboard-config.model';

import { IStepConfig } from '@/features/user/store/createUser.types';

interface IStepIndication {
  currentStep: number;
  steps: IStepConfig[];
  userType: TUserCreationType;
}

export function StepIndication({ currentStep, steps, userType }: IStepIndication) {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col p-7 h-full text-secondary justify-between">
      <div className="flex flex-col gap-6">
        <span className="typo-h6-bold">{t(`pages.dashboard.createUser.form.pages.indication.title.${userType}`)}</span>
        <div className="flex flex-col gap-5">
          <div className="flex flex-col">
            <span className="typo-number-semiBold-l">
              {t('pages.dashboard.createUser.form.pages.indication.step', { value: '1' })}
            </span>
            <span className="typo-body-regular-paragraph">
              {t('pages.dashboard.createUser.form.pages.indication.stepDescription1')}
            </span>
          </div>
          <div>
            <Stepper
              direction="vertical"
              activeStepIndex={currentStep}
              items={steps.map((step, index) => ({
                id: `step-${index}`,
                title: step.name,
              }))}
            />
          </div>
          <div className="flex flex-col text-tertiary">
            <span className="typo-number-semiBold-l">
              {' '}
              {t('pages.dashboard.createUser.form.pages.indication.step', { value: 2 })}
            </span>
            <span className="typo-body-regular-paragraph">
              {t('pages.dashboard.createUser.form.pages.indication.stepDescription2')}
            </span>
          </div>
          <div className="flex flex-col text-tertiary">
            <span className="typo-number-semiBold-l">
              {' '}
              {t('pages.dashboard.createUser.form.pages.indication.step', { value: 3 })}
            </span>
            <span className="typo-body-regular-paragraph">
              {t(`pages.dashboard.createUser.form.pages.indication.stepDescription3.${userType}`)}
            </span>
          </div>
        </div>
      </div>
      <div className="flex flex-col gap-6">
        <Divider />
        <div>
          <div className="flex items-center gap-2 text-secondary mb-3">
            <Icon name="info" />
            <span className="typo-body-bold-paragraphLarge">
              {t('pages.dashboard.createUser.form.pages.indication.fieldRequirements')}
            </span>
          </div>
          <div>
            <span className="text-icon-error mr-1">*</span>
            <span className="typo-body-bold-paragraph">
              {t('pages.dashboard.createUser.form.pages.indication.required')}
            </span>
            {' – '}
            <span>{t('pages.dashboard.createUser.form.pages.indication.forUserCreation')}</span>
          </div>
          <div>
            <span className="typo-body-bold-paragraph text-interactive">
              ({t('pages.dashboard.createUser.form.pages.indication.optional')})
            </span>
            {' – '}
            <span>{t('pages.dashboard.createUser.form.pages.indication.notRequestedKYC')}</span>
          </div>
          <p className="mt-3">{t('pages.dashboard.createUser.form.pages.indication.description')}</p>
        </div>
      </div>
    </div>
  );
}
